app.controller('blogController', function ($scope, safeApply, blogService) {

  $scope.route = 'blog'
  
  initController()

  $scope.curPage      = 1
  $scope.itemsPerPage = 6
  $scope.maxSize      = 5
    
  $scope.setCurrentPage = function (page) { 
    $scope.curPage = page
    $scope.updatePagination()
  }
  $scope.updatePagination = function () {
    var begin            = (($scope.curPage - 1) * $scope.itemsPerPage)
    var end              = begin + $scope.itemsPerPage
    $scope.filteredItems = $scope.posts.all_posts.slice(begin, end)
    safeApply($scope)
  }
  $scope.nextPrev = function(action) { 
    switch (action) {
      case 'next':
        if ($scope.curPage < $scope.numOfPages) {
          $scope.curPage++
          $scope.updatePagination()
        }
        break
      case 'prev':
        if ($scope.curPage > 1) {
          $scope.curPage--
          $scope.updatePagination()
        }
        break
      
    }
  }



  async function initController() {
    $scope.menu_background_solid = true

    let posts = await blogService.getBlogPosts()
    $scope.posts = {
      all_posts    : posts.data.data.posts,
      popular_posts: posts.data.data.popular_posts,
      recent_posts : posts.data.data.recent_posts
    }
    console.log('$scope.posts :>> ', $scope.posts);

    $scope.numOfPages = Math.ceil($scope.posts.all_posts.length / $scope.itemsPerPage)
    $scope.updatePagination()		
    safeApply($scope)	
    initComponents()    
  }

  

  
  // *************************************************************************
  // Leave this at the bottom - do not put any functions below this section **
  // *************************************************************************
  function initComponents() {
    feather.replace()
    
    //Menu
    // Toggle menu
    $scope.toggleMenu = () => {
        document.getElementById('isToggle').classList.toggle('open')
        var isOpen = document.getElementById('navigation')
        if (isOpen.style.display === "block") {
            isOpen.style.display = "none"
        } else {
            isOpen.style.display = "block"
        }
    }

    //Menu Active
    function getClosest(elem, selector) {

        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function (s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) { }
                    return i > -1;
                };
        }

        // Get the closest matching element
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.matches(selector)) return elem;
        }
        return null;

    };

    function activateMenu() {
        var menuItems = document.getElementsByClassName("sub-menu-item");
        if (menuItems) {

            var matchingMenuItem = null;
            for (var idx = 0; idx < menuItems.length; idx++) {
                if (menuItems[idx].href === window.location.href) {
                    matchingMenuItem = menuItems[idx];
                }
            }

            if (matchingMenuItem) {
                matchingMenuItem.classList.add('active');
                var immediateParent = getClosest(matchingMenuItem, 'li');
                if (immediateParent) {
                    immediateParent.classList.add('active');
                }

                var parent = getClosest(matchingMenuItem, '.parent-menu-item');
                if (parent) {
                    parent.classList.add('active');
                    var parentMenuitem = parent.querySelector('.menu-item');
                    if (parentMenuitem) {
                        parentMenuitem.classList.add('active');
                    }
                    var parentOfParent = getClosest(parent, '.parent-parent-menu-item');
                    if (parentOfParent) {
                        parentOfParent.classList.add('active');
                    }
                } else {
                    var parentOfParent = getClosest(matchingMenuItem, '.parent-parent-menu-item');
                    if (parentOfParent) {
                        parentOfParent.classList.add('active');
                    }
                }
            }
        }
    }

    // Clickable Menu
    if(document.getElementById("navigation")){
      var elements = document.getElementById("navigation").getElementsByTagName("a");
      for(var i = 0, len = elements.length; i < len; i++) {
        elements[i].onclick = function (elem) {
          if(elem.target.getAttribute("href") === "javascript:void(0)") {
            var submenu = elem.target.nextElementSibling.nextElementSibling;
            submenu.classList.toggle('open');
          }
        }
      }
    }

    // Menu sticky
    function windowScroll() {
      const navbar = document.getElementById("topnav");
      if(navbar!=null){
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          // navbar.classList.add("nav-sticky");
        } else {
          // navbar.classList.remove("nav-sticky");
        }
      }
    }

    window.addEventListener('scroll', (ev) => {
        ev.preventDefault();
        windowScroll();
    })

    // back-to-top
    var mybutton = document.getElementById("back-to-top");
    window.onscroll = function () {
        scrollFunction();
    }

    function scrollFunction() {
      if(mybutton!=null){
        if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
          mybutton.style.display = "block"
        } else {
          mybutton.style.display = "none"
        }
      }
    }

    $scope.topFunction = () => {
      document.body.scrollTop            = 0
      document.documentElement.scrollTop = 0
    }

  }   
  
})  